import EngagementsBadges from "./engagements-badges"
import EngagementsEvents from "./engagements-events"
import EngagementsStatus from "./engagements-status"
import PricingStatusBadge from "../../../../pricing-status-badge"
import Tooltip from "../../../../tool-tip"
import { getStatusID } from "../../../../../utils"
import { STATUS_OPTIONS } from "../../../../../constants"
import { SubscriptionLogV2 } from "../../../../../../types"

type Props = {
  info: SubscriptionLogV2
  onClick: (id: string) => void
}

const EngagementsCell = ({ info, onClick }: Props) => {
  const {
    email,
    source,
    id,
    first_name,
    last_name,
    sms_followup_sent,
    dashboard_pageview_count,
    rate_alert_email_open_count,
    sms_allowed,
    pricing_status
  } = info
  const status = getStatusID(info)
  const selectedStatusOption = STATUS_OPTIONS.find(so => so.id === status)

  const name =
    first_name || last_name ? `${first_name} ${last_name}` : "Unnamed"

  return (
    <td
      className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer"
      colSpan={2}
      onClick={() => onClick(id)}
    >
      <div className="flex items-center">
        <div className="font-bold mr-2 hover:border-b border-neutral-500 leading-none">
          {name}
        </div>
        <Tooltip
          toolTipNode={<EngagementsStatus status={status} />}
          placement="top"
          text={selectedStatusOption?.tooltipText ?? ""}
        />
      </div>
      <div className="text-neutral-400 text-sm mt-2">{email}</div>
      <div className="flex items-center mt-2">
        <EngagementsBadges className="px-3" source={source} />
        <EngagementsEvents
          className="px-3"
          subscriptionId={id}
          dashboardPageviewCount={dashboard_pageview_count}
          rateAlertEmailOpenCount={rate_alert_email_open_count}
          smsAllowed={sms_allowed}
          smsFollowupSent={sms_followup_sent}
        />
        <PricingStatusBadge
          className="px-3 ml-1"
          pricingStatus={pricing_status}
        />
      </div>
    </td>
  )
}

export default EngagementsCell
